import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";

// Style
import Styles from "../../../../Views/Operations/BusinessDescription/BusinessDescription.module.css";
import Style from "./SipocDiagram.module.css";
// Icons
// import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
// import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

// MUI Components
import { Box, Button, Typography, Paper, styled } from "@mui/material";

// Custom Components
import ActivityBar from "../../ActivityBar/ActivityBar";
import BusinessDescriptionForm from "../../../../components/Reusable/Forms/BusinessDescriptionForm";
import SipocModal from "./SipocModal";

import SectionSlider from "../../SectionSlider/SectionSlider";

import { sections, sectionPaths } from "../../../../constants/sectionData";

import { apiService } from "../../../../api/apiService";
import useFunctionOptions from "../../utils/useFunctionOptions";
import { getFileImagePath } from "../../utils/fileUtils";
import RoutineStyle from "../../../GlobalPolicies/RoutineUpload.module.css";
import UserFileViewPopup from "../../Popup/UserFileViewPopup";


interface LocationState {
  management: any;
}

const StyledTableRow = styled(Box)<{ status: string }>(({ status }) => ({
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  borderRadius: "10px",
  border: "1px solid #bbbbbb",
  boxShadow: `4px 0px 0px 0px ${status === "Approved"
    ? "#058B2B"
    : status === "Reverted"
      ? "#ffebeb"
      : status === "Pending"
        ? "#FF5C00"
        : "transparent"
    } inset`,
}));

const SipocDiagram: React.FC<{ onOpen?: () => void }> = ({
  onOpen = () => { },
}) => {
  const { instance } = useMsal();

  // New state variable to store selected SIPOC ID
  const [selectedSipocId, setSelectedSipocId] = useState<string | null>(null);
    const [openFilePopupId, setOpenFilePopupId] = useState<string | null>(null);


  // const location = useLocation();
  // const locationState = location.state as LocationState | undefined;
  // const management = localStorage.getItem("management") || "Default Location Name";
  const management =
    localStorage.getItem("management") || "Default Location Name";

  // useEffect(() => {
  //   if (locationState?.management) {
  //     setLocationName(locationState.management);
  //   }
  // }, [locationState?.management]);

  const [isModalOpen, setIsModalOpen] = useState(false);

  // Open the modal and set the selected SIPOC ID
  const handleOpenModal = (id: string) => {
    setSelectedSipocId(id);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

   const handleOpenFilePopup = (fileId: string) => {
    setOpenFilePopupId(fileId);
  };

  const handleCloseFilePopup = () => {
    setOpenFilePopupId(null);
  };
  

  // State Variables
  const [functionL1, setFunctionL1] = useState("");
  const [functionL2, setFunctionL2] = useState("");

  // const [l1Options, setL1Options] = useState<string[]>([]);
  // const [l2Options, setL2Options] = useState<string[]>([]);
  const [sipocDataList, setSipocDataList] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showSIPOC, setShowSIPOC] = useState(false);

  // Use the custom hook to fetch options for each level
  const { options: l1Options, loading: l1Loading } = useFunctionOptions(
    "l1",
    ""
  );
  const { options: l2Options, loading: l2Loading } = useFunctionOptions(
    "l2",
    functionL1
  );

  // Input Fields
  const [sipocData, setSipocData] = useState({
    clients: [""],
    outputs: [""],
    inputs: [""],
    suppliers: [""],
    processes: [""],
    resources: [""],
    objectives: [""],
  });

  const handleApplyFilter = async () => {
    if (!functionL1 || !functionL2) {
      alert("Please select both Function L1 and L2");
      return;
    }

    setIsLoading(true);
    try {
      const response = await apiService(
        "/management/business_description_by_functions",
        "GET",
        {
          function_l1: functionL1,
          function_l2: functionL2,
          management: management,
        },
        undefined,
        instance as PublicClientApplication
      );

      if (response?.status === "success") {
        // Handle the new response structure with separate lists
        if (response.data?.new_bd_list && response.data?.existing_bd_list) {
          // Combine both lists into one array for display
          const combinedList = [
            ...response.data.new_bd_list,
            ...response.data.existing_bd_list,
          ];

          setSipocDataList(combinedList);
          console.log("Combined SIPOC data:", combinedList);
        } else if (Array.isArray(response.data)) {
          // Handle legacy response format (just in case)
          setSipocDataList(response.data);
          console.log("Legacy SIPOC data format:", response.data);
        } else {
          console.error("Unexpected response structure:", response.data);
        }
      } else {
        console.error("API returned non-success status:", response);
      }
    } catch (error) {
      console.error("Error fetching SIPOC data:", error);
    } finally {
      setIsLoading(false);
    }
  };


  // Breadcrumbs Data
  const breadcrumbs = [
    <Link key="1" color="#000" to="/">
      Home
    </Link>,
    <Link key="2" color="#000" to="/operations/management">
      Evidence Upload
    </Link>,
    <Link key="3" color="#000" to="/operations/management">
      Management
    </Link>,
    <Typography key="4" sx={{ fontWeight: "bold" }}>
      {management}
    </Typography>,
  ];

  console.log("sipocDataList", sipocDataList);

  return (
    <>
      {/* Activity Bar */}
      <ActivityBar breadcrumbs={breadcrumbs} />
      {/* Main Content */}
      <div className={Styles.mainContent}>
        {/* Section Slider */}
        <SectionSlider
          sections={sections}
          sectionPaths={sectionPaths}
          highlightSection={"Business Description"}
          highlightColor="#D7A833"
          defaultColor="#666"
        />

        {/* Select Function and Apply Filter */}
        {!showSIPOC ? (
          <div className={Styles.selectFunc}>
            <Box className={Styles.filterMainBox}>
              <div className={Styles.selectMainBox}>
                <div className={Styles.selectMain}>
                  <label>Select Function L1</label>
                  <select
                    value={functionL1}
                    onChange={(e) => setFunctionL1(e.target.value)}
                  >
                    <option value="" disabled>
                      Select Function L1
                    </option>
                    {l1Options.map((option, index) => (
                      <option key={index} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                </div>
                <div className={Styles.selectMain}>
                  <label>Select Function L2</label>
                  <select
                    value={functionL2}
                    onChange={(e) => setFunctionL2(e.target.value)}
                    disabled={!functionL1} // Disable until L1 is selected
                  >
                    <option value="" disabled>
                      Select Function L2
                    </option>
                    {l2Options.map((option, index) => (
                      <option key={index} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <button
                className={Styles.filterApplyBtn}
                onClick={handleApplyFilter}
                disabled={isLoading}
              >
                {isLoading ? "Loading..." : "Apply Filter"}
              </button>
            </Box>

            {sipocDataList.length > 0 ? (
              sipocDataList.map((sipoc, index) => (
                <Paper
                  key={index}
                  elevation={0}
                  className={Styles.createNewBoxSipoc}
                  sx={{ p: 2 }}
                >
                  {/* Differentiate between regular SIPOC and existing BD file */}
                  {sipoc.is_existing_bd ? (
                    // Render existing BD file card
                    <>
                      <StyledTableRow sx={{ mb: 2 }} status={sipoc.status}>
                        <Paper
                          key={sipoc.id}
                          className={RoutineStyle.bordercard}
                          sx={{ width: "100%", pb: 2 }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              gap: "10px",
                              p: 2,
                              justifyContent: "space-between",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                textAlign: "left",
                                gap: "5px",
                              }}
                            >
                              {sipoc.doc_path && (
                                <div>
                                  <img
                                    src={getFileImagePath(sipoc.doc_path)}
                                    alt="File"
                                    height={50}
                                    width={50}
                                  />
                                </div>
                              )}
                              <div>
                                {sipoc.file_name && (
                                  <p>{sipoc.file_name.split("_").slice(5).join("_")}</p>
                                )}
                                <h4>{sipoc.file_size || ""}</h4>
                              </div>
                            </div>
                            {sipoc.function_l1 && (
                              <div style={{ textAlign: "left", width: "20%" }}>
                                <h4>Function L1</h4>
                                <p>{sipoc.function_l1}</p>
                              </div>
                            )}
                            {sipoc.function_l2 && (
                              <div style={{ textAlign: "left", width: "20%" }}>
                                <h4>Function L2</h4>
                                <p>{sipoc.function_l2}</p>
                              </div>
                            )}

                            <div style={{ textAlign: "left", width: "20%" }}>
                              <h4>Create Date</h4>
                              <p>{new Date(sipoc.created_at).toLocaleDateString()}</p>
                            </div>
                            <div style={{ textAlign: "left", width: "20%" }}>
                              <h4>Status</h4>
                              <p
                                className={RoutineStyle.statuspending}
                                style={{
                                  color:
                                    sipoc.status === "Reverted"
                                      ? "#F00"
                                      : sipoc.status === "Approved"
                                        ? "#058B2B"
                                        : sipoc.status === "Pending"
                                          ? "#FF5C00"
                                          : "#000",
                                }}
                              >
                                {sipoc.status}
                              </p>
                            </div>
                          </Box>
                          <hr />
                          <div className={Style.spoicaction}>
                            <div className="userDetail">
                              <h4>Created by</h4>
                              <div className="dFlex">
                                <div className="flexItem">
                                  <h5>{sipoc.created_by}</h5>
                                </div>
                              </div>
                            </div>
                            <div className="userDetail">
                              <h4>Created Date</h4>
                              <h5 className="date">
                                {new Date(sipoc.created_at).toLocaleDateString()}
                              </h5>
                            </div>
                            <div className="userDetail">
                              <h4>Status</h4>
                              <h5 className={`status-${sipoc.status.toLowerCase()}`}>
                                {sipoc.status}
                              </h5>
                            </div>
                            <Button
                              className="abi_button"
                              onClick={() => handleOpenFilePopup(sipoc.id)}
                            >
                              View more
                            </Button>
                            {openFilePopupId === sipoc.id && (
                              <UserFileViewPopup
                                onClose={handleCloseFilePopup}
                                open={true}
                                name={sipoc.file_name}
                                id={sipoc.id}
                                functionl1={sipoc.function_l1}
                                date={sipoc.created_at}
                                sectionTitle={"Business Description"}
                                apiPath={`/management/existing_business_desc/${sipoc.id}`}
                              />
                            )}
                          </div>
                        </Paper>
                      </StyledTableRow>
                    </>
                  ) : (
                    // Render regular SIPOC diagram
                    <>
                      <h4 className={Style.cardtitle}>SIPOC Diagram</h4>

                      <Box className={Style.spoicdata}>
                        <Box sx={{ width: "25%" }}>
                          <Typography
                            variant="h5"
                            className={Style.spoicdatatitle}
                          >
                            Clients
                          </Typography>
                          <Typography className={Style.spoicdatatext}>
                            {sipoc.clients &&
                              sipoc.clients
                                .split("|")
                                .map((client: string, index: number) => (
                                  <Typography
                                    key={index}
                                    component="span"
                                    display="block"
                                  >
                                    {client.trim()}
                                  </Typography>
                                ))}
                          </Typography>
                        </Box>
                        <Box sx={{ width: "25%" }}>
                          <Typography
                            variant="h5"
                            className={Style.spoicdatatitle}
                          >
                            Inputs
                          </Typography>
                          <Typography className={Style.spoicdatatext}>
                            {sipoc.inputs &&
                              sipoc.inputs
                                .split("|")
                                .map((input: string, index: number) => (
                                  <Typography
                                    key={index}
                                    component="span"
                                    display="block"
                                  >
                                    {input.trim()}
                                  </Typography>
                                ))}
                          </Typography>
                        </Box>
                        <Box sx={{ width: "25%" }}>
                          <Typography
                            variant="h5"
                            className={Style.spoicdatatitle}
                          >
                            Outputs
                          </Typography>
                          <Typography className={Style.spoicdatatext}>
                            {sipoc.outputs &&
                              sipoc.outputs
                                .split("|")
                                .map((output: string, index: number) => (
                                  <Typography
                                    key={index}
                                    component="span"
                                    display="block"
                                  >
                                    {output.trim()}
                                  </Typography>
                                ))}
                          </Typography>
                        </Box>
                        <Box sx={{ width: "25%" }}>
                          <Typography
                            variant="h5"
                            className={Style.spoicdatatitle}
                          >
                            Suppliers
                          </Typography>
                          <Typography className={Style.spoicdatatext}>
                            {sipoc.suppliers &&
                              sipoc.suppliers
                                .split("|")
                                .map((supplier: string, index: number) => (
                                  <Typography
                                    key={index}
                                    component="span"
                                    display="block"
                                  >
                                    {supplier.trim()}
                                  </Typography>
                                ))}
                          </Typography>
                        </Box>
                      </Box>

                      <div className={Style.spoicaction}>
                        <div className="userDetail">
                          <h4>Created by</h4>
                          <div className="dFlex">
                            <div className="flexItem">
                              <h5>{sipoc.created_by}</h5>
                            </div>
                          </div>
                        </div>
                        <div className="userDetail">
                          <h4>Created Date</h4>
                          <h5 className="date">
                            {new Date(sipoc.created_at).toLocaleDateString()}
                          </h5>
                        </div>
                        <div className="userDetail">
                          <h4>Status</h4>
                          <h5 className={`status-${sipoc.status.toLowerCase()}`}>
                            {sipoc.status}
                          </h5>
                        </div>
                        <Button
                          className="abi_button"
                          onClick={() => handleOpenModal(sipoc.id.toString())}
                        >
                          View more
                        </Button>
                      </div>
                    </>
                  )}
                </Paper>
              ))
            ) : (
              <Typography
                sx={{ display: "flex", justifyContent: "center", mt: 3 }}
              >
                No SIPOC data available
              </Typography>
            )}
          </div>
        ) : (
          <BusinessDescriptionForm
            functionL1={functionL1}
            functionL2={functionL2}
            management={management}
          />
        )}
      </div>
      <SipocModal
        open={isModalOpen}
        onClose={handleCloseModal}
        sipocId={selectedSipocId}
        functionL1={functionL1}
        functionL2={functionL2}
      />
    </>
  );
};

export default SipocDiagram;
